export enum Variant {
	OutlookCalendar = 'outlook-calendar-integration',
}
